import React from 'react';
import AccountStatements from './AccountStatements';
import SubscriptionAgreements from './SubscriptionAgreements';
import TaxDocuments from './TaxDocuments';
import TradeDocuments from './TradeDocuments';

import './Documents.scss';

const Documents = () => {
  return (
    <div className='documents'>
      <TaxDocuments />
      <AccountStatements />
      <TradeDocuments />
      <SubscriptionAgreements />
    </div>
  );
};

export default Documents;
